var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoPricelabs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0494b",
  d: "M18 36c9.94 0 18-8.06 18-18S27.941 0 18 0 0 8.06 0 18s8.059 18 18 18"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m14.26 10.42 2.54 2.673-5.558 5.188 5.559 6.288-2.7 2.516-8.417-8.803zm6.913 0 8.576 7.86-8.416 8.804-2.7-2.516 5.558-6.288-5.558-5.187z",
  clipRule: "evenodd"
})));
export { SvgLogoPricelabs as ReactComponent };
export default __webpack_public_path__ + "c28a488dd6287976cbb0d625d58d8a92.svg";